export const ACTION_TYPE_NAME = {
    // Workflow Actions
    TEXT: "send_WA_DM_text",
    TEMPLATE: "send_WA_DM_template",
    CAROUSEL_TEMPLATE: "send_WA_DM_Carousel_template",
    SEND_ORDER_DETAIL_TEMPLATE: "send_Order_Details_template",
    SAVE_DATA: "save_variable",
    VARIABLE_ASSIGNMENT: "static_variable_assignment",
    RESET_DATA: "reset_variable",
    SEND_MEDIA: "send_WA_DM_media",
    SAVE_CONTACT: "save_contact",
    REMOVE_CONTACT: "remove_contact",
    ASSIGN_TAG: 'thread_tag_assigned',
    REMOVE_TAG: 'thread_tag_removed',
    TALK_TO_AGENT: "talk_to_agent",
    CUSTOM_API: "Custom_API_Call",
    CONDITION: "Custom_Variable_Condition",
    AWAIT_WEBHOOK: "await_webhook",
    RETRIEVE_CONTACT: "retrieve_contact",

    VOICE_CALL: "voice_call",
    ARCHIVE_CHAT: 'archive_chat',

    // Inbox Actions
    TIMEOUT_TRIGGER_EXECUTION: "timeout_trigger_execution",
    MISCELLANEOUS: "Miscellaneous"
}
